<template>
  <div class="rt-list-header">
    <div class="rt-list-header-top">
      <div v-if="!!$slots.icon" class="header-icon">
        <slot name="icon" />
      </div>
      <div class="header-content">
        <div v-if="hasIcon" class="rt-list-header-icon">
          <rt-icon :name="icon" :img-src="iconSrc" :size="32" />
        </div>
        <slot />
      </div>
      <div class="header-btns">
        <slot name="btn" />
      </div>
      <div class="header-search">
        <slot name="search" />
      </div>
      <div v-if="hasBack" class="header-back">
        <slot name="back">
          <rt-button
            class="rt-btn-back"
            icon-name="rt-base-back"
            @click="$router.back"
            >{{ $tx('返回', 'xpc.detailheader.back') }}</rt-button
          >
        </slot>
      </div>
    </div>
  </div>
</template>

<script>
import RtButton from '../../button/rtButton';
export default {
  name: 'RtListHeader',
  components: { RtButton },
  props: {
    icon: {
      type: String,
      default: ''
    },
    iconSrc: {
      type: String,
      default: ''
    },
    showBack: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    hasIcon() {
      return !!this.icon || !!this.iconSrc;
    },
    hasBack() {
      return !!this.showBack || !!this.$slots.back;
    }
  }
};
</script>



// WEBPACK FOOTER //
// rtListHeader.vue?7ec4e908